import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { BED_STATUS, BRAND, errMsg, inr, today } from "./constants";

export function BedSheet({ bed, onClose, authFetch, API, onSaved }) {
  const [g, setG] = useState({ name: "", phone: "", check_in: today(), check_out: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (bed) setG({ name: bed.guest?.name || "", phone: bed.guest?.phone || "", check_in: bed.guest?.check_in || today(), check_out: bed.guest?.check_out || "" });
  }, [bed]);

  const save = async (data) => {
    setBusy(true);
    try { await authFetch({ method: "patch", url: `${API}/homestay/beds/${bed.id}`, data }); toast.success("Bed updated"); onSaved(); }
    catch (e) { toast.error(errMsg(e, "Could not update bed")); }
    finally { setBusy(false); }
  };

  const cls = "w-full rounded-xl border-2 px-3 py-2 text-sm";
  return (
    <Dialog open={!!bed} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="bed-sheet" className="max-w-md">
        {bed && (
          <>
            <DialogHeader>
              <DialogTitle style={{ color: BRAND.green }}>Bed {bed.label}</DialogTitle>
              <div className="text-xs" style={{ color: BRAND.muted }}>{inr(bed.nightly_rate)}/night · {inr(bed.monthly_rate)}/month</div>
            </DialogHeader>
            <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: BRAND.muted }}>Status</div>
            <div className="flex flex-wrap gap-2">
              {Object.entries(BED_STATUS).map(([k, s]) => (
                <button key={k} disabled={busy} data-testid={`bed-status-${k}`} onClick={() => save({ status: k })}
                  className="rounded-full px-3 py-1.5 text-xs font-bold border-2 transition-transform hover:-translate-y-0.5"
                  style={{ borderColor: s.color, background: bed.status === k ? s.color : "#fff", color: bed.status === k ? "#fff" : s.color }}>
                  {s.label}
                </button>
              ))}
            </div>
            <div className="mt-2 text-[10px] uppercase tracking-widest font-bold" style={{ color: BRAND.muted }}>Guest tag</div>
            <div className="grid grid-cols-2 gap-2">
              <input data-testid="bed-guest-name" placeholder="Guest name" className={`${cls} col-span-2`} value={g.name} onChange={(e) => setG({ ...g, name: e.target.value })} />
              <input data-testid="bed-guest-phone" placeholder="Phone" className={`${cls} col-span-2`} value={g.phone} onChange={(e) => setG({ ...g, phone: e.target.value })} />
              <input type="date" data-testid="bed-guest-checkin" className={cls} value={g.check_in} onChange={(e) => setG({ ...g, check_in: e.target.value })} />
              <input type="date" data-testid="bed-guest-checkout" className={cls} value={g.check_out} onChange={(e) => setG({ ...g, check_out: e.target.value })} />
            </div>
            <div className="mt-3 flex gap-2">
              <button disabled={busy || !g.name} data-testid="bed-assign-guest" onClick={() => save({ guest: { ...g, phone: g.phone || null, check_out: g.check_out || null } })}
                className="flex-1 rounded-full py-2.5 text-sm font-bold text-white disabled:opacity-50" style={{ background: BRAND.green }}>
                Assign / update guest
              </button>
              {bed.guest && (
                <button disabled={busy} data-testid="bed-clear-guest" onClick={() => save({ clear_guest: true })}
                  className="rounded-full px-4 py-2.5 text-sm font-bold border-2" style={{ borderColor: "#DC2626", color: "#DC2626" }}>
                  Check out
                </button>
              )}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
